<template>
  <div class="testinmony" style="min-height:300px;">
    <button
      id="testimonyButton"
      class="button-icon"
      v-on:click="toggleClick"
    >Submit a Review
    </button>
    <div v-if="testClick">
      <review-form />
    </div>
  <!--  -->
    <div v-for="info in pageOfItems" v-bind:key="info.id">
      <div class="borderlayout">
        <div class="profileimage">
          <img class="imagesize" :src="info.image" />
        </div>
        <div class="infolayout">
          <p id='name' class="titleinfo"><b>Full Name: </b>{{ info.name }}</p>
          <p id='rating' class="titleinfo" style="display: flex;">
            <b>Rating: </b>
            <star-view class="ratingPosition" :total="info.rating"/>
          </p>
          <p id='description' class="titleinfo"><b>Feedback: </b>{{ info.more }}</p>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <jw-pagination :items="listReviews" @changePage="onChangePage"></jw-pagination>
    </div>
  </div>
</template>

<script>
import db from '../../config/db'
import Swal from 'sweetalert2'
import reviewForm from '../components/forms/reviewForm.vue'
import starView from '../components/star/starView.vue'

export default {
  name: 'testimony',
  components: {
    reviewForm,
    starView
  },
  data () {
    return {
      listReviews: [],
      testClick: false,
      pageOfItems: []
    }
  },
  mounted () {
    this.getReviews()
    // this.$store.commit('checkENV')
  },
  methods: {
    toggleClick () {
      if (this.testClick === false) {
        this.testClick = true
      } else if (this.testClick === true) {
        this.testClick = false
      }
    },
    getReviews () {
      const vm = this
      let reviews = []
      let data = {}
      db.firestore.collection('reviews')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // Using image name to obtain image url
            db.storing.ref('images')
              .child(doc.data().image)
              .getDownloadURL()
              .then((downloadURL) => {
                data = {
                  id: doc.id,
                  name: doc.data().name,
                  image: downloadURL,
                  rating: doc.data().rating,
                  more: doc.data().more,
                  date: doc.data().date
                }
                reviews.push(data)
                reviews = reviews.sort(
                  (a, b) => b.date - a.date
                )
              })
          })
        })
      vm.listReviews = reviews
    },
    notication (text, icon) {
      Swal.fire({
        title: text,
        icon: icon,
        timer: 1500,
        showConfirmButton: false
      })
    },
    onChangePage (pageOfItems) {
      this.pageOfItems = pageOfItems
      // window.scrollTo(0, 150)
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../assets/common.scss";

.ratingPosition {
  margin: 0 auto;
  margin-left: -5%;
}

.borderlayout {
  display: flex;
  flex-direction: row;
  margin : 0 auto;
  min-height: 160px;
  // max-height: 240px;
  width: 60%;
  box-sizing: border-box;
  border: .1px solid $content-colour;
  margin-bottom: 5px;
  margin-top: 5px;

  @media (max-width: 760px) {
    flex-direction: column;
    width: 95%;
    min-height: 300px;
    // max-height: 480px;
    font-size: 1rem;
  }

  .profileimage {
    height: 100%;
    width: 25%;

    @media (max-width: 760px) {
      width: 100%;
      margin: 0 auto;
    }

    .imagesize {
      min-height: 160px;
      max-height: 238px;
      min-width: 35%;
      max-width: 100%;
      vertical-align: middle;
    }
  }

  .infolayout {
    width: 75%;
    box-sizing: border-box;
    border-left: .1px solid $content-colour;

    @media (max-width: 760px) {
      width: 100%;
      border-top: .1px solid $content-colour;
      border-left: none;
    }
  }

  .titleinfo {
    text-align: left;
    margin-left: 10px;
    margin-right: 10px;
    overflow-wrap: break-word;
    hyphens: auto;

    @media (max-width: 760px) {
      font-size: .8rem;
      margin: auto 5px 2px 5px;
    }
  }
}

.card-footer /deep/ {
  margin-top: 20px;
  .page-link {
    position: relative;
    display: block;
    padding: .5rem .75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: $active-colour;
    background-color: #fff;
    border: 1px solid #dee2e6;
  }

  a {
    color: $active-colour;
    text-decoration: none;
    background-color: transparent;
  }

  .page-item.disabled .page-link {
    color: #6c757d;
    pointer-events: none;
    cursor: auto;
    background-color: #fff;
    border-color: #dee2e6;
  }

  .page-item.active .page-link {
    z-index: 1;
    color: #fff;
    background-color: #658FC6;
    border-color: #658FC6;
  }
}

</style>
